export default __webpack_public_path__ + "static/media/LUX.07a6c829.svg";